import React, { useEffect, useState } from 'react';
import './GoToWorkshop.scss';
import CustomBtn from '../../../../components/CustomBtn/CustomBtn';
import { baseStrapiURL } from '../../../../services/config';
import StrapiImageWithSkeleton from '../../../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';

export default function GoToWorkshop({ content }) {

    const [backgroundImage, setBackgroundImage] = useState(baseStrapiURL + content.ArrièrePlan.url);

    useEffect(() => {
        const checkWebPSupport = () => {
            const img = new Image();
            img.onload = () => {
                if (img.height > 0 && img.width > 0) {
                    setBackgroundImage(baseStrapiURL + content.ArrièrePlan.url);
                }
            };

        };
        checkWebPSupport();
    }, []);

    return (
        <div
            className='go_to_workshop'
            style={{ backgroundImage: `url(${backgroundImage})` }}
        >
            {
                content.AvecCadreEtOmbre ?
                    <div className="go_to_workshop__image-container">
                        <div className="go_to_workshop__image-wrapper">
                            <StrapiImageWithSkeleton
                                picture={content.Photo}
                                loading="lazy"
                                size='small'
                                className="go_to_workshop__picture"
                            />
                        </div>
                        <div className="go_to_workshop__image-shadow"></div>
                    </div>
                    :
                        <StrapiImageWithSkeleton
                            picture={content.Photo}
                            loading="lazy"
                            size='small'
                            className="go_to_workshop__picture"
                        />

            }
            <div className='go_to_workshop__right_Content'>
                <h2
                    className={content.Typographie1 === 'Great Vibes' ? "go_to_workshop__title1 handwrite-title" : "go_to_workshop__title1 classic-title"}
                >
                    {content.Titre}
                </h2>
                <h2
                    className={content.Typographie2 === 'Great Vibes' ? "go_to_workshop__title2 handwrite-title" : "go_to_workshop__title2 classic-title"}
                >
                    {content.Titre2}
                </h2>
                <CustomBtn
                    type={'external'}
                    title={content.Bouton.TexteBouton}
                    link={content.Bouton.LienBouton}
                    bkg_color={'#EEE6DB'}
                    bkg_color_hover={'#361215'}
                    text_color={'#361215'}
                    text_color_hover={'#EEE6DB'}
                    border_color={'#361215'}
                    border_color_hover={'#361215'}
                    font_family={"Great Vibes"}
                    font_size={'30px'}
                    font_weight={'normal'}
                    border_radius={'3px'}
                    width={'330px'}
                    height={'60px'}
                    margin={'30px 0'}
                />
            </div>
        </div>
    )
}